const AbkhaziaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110689)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M33.9949 5.71437C30.3876 2.18 25.4487 0 19.9997 0C18.2606 0 13.1721 2.18 9.56494 5.71437H33.9949Z"
        fill="#6DA544"
      />
      <path
        d="M20.0004 17.144H39.7963C39.5077 15.1264 38.9184 13.2061 38.0746 11.4297H19.1309L20.0004 17.144Z"
        fill="#6DA544"
      />
      <path
        d="M1.9259 28.5708H38.0742C38.9181 26.7945 39.5074 24.874 39.796 22.8564H0.204102C0.492773 24.8741 1.08191 26.7946 1.9259 28.5708Z"
        fill="#6DA544"
      />
      <path
        d="M6.00488 34.2861C9.61215 37.8205 14.5511 40.0005 20 40.0005C25.449 40.0005 30.3879 37.8205 33.9952 34.2861H6.00488Z"
        fill="#6DA544"
      />
      <path d="M20 0C9.92457 0 1.59066 7.45086 0.204102 17.1429H20V0Z" fill="#D80027" />
      <path
        d="M10.0004 15.3334L9.13086 13.5944V10.1161L11.3048 8.37695L13.4787 10.1161V12.7248L14.3482 11.8552V13.5944L12.6091 15.3334H10.0004Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.32289 10L5.55313 10.7086H6.29812L5.69539 11.1466L5.9257 11.8552L5.32289 11.4172L4.72008 11.8552L4.95039 11.1466L4.34766 10.7086H5.09266L5.32289 10Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.06166 8.25977L7.29189 8.96836H8.03697L7.43416 9.40641L7.66439 10.1149L7.06166 9.67703L6.45893 10.1149L6.68924 9.40641L6.08643 8.96836H6.83135L7.06166 8.25977Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.80092 6.52148L9.03115 7.23008H9.77607L9.17342 7.66813L9.40357 8.37664L8.80092 7.93875L8.19811 8.37664L8.42834 7.66813L7.82568 7.23008H8.57061L8.80092 6.52148Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2857 10L17.0555 10.7086H16.3105L16.9132 11.1466L16.683 11.8552L17.2857 11.4172L17.8885 11.8552L17.6583 11.1466L18.2609 10.7086H17.516L17.2857 10Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.5464 8.25977L15.3162 8.96836H14.5713L15.1739 9.40641L14.9437 10.1149L15.5464 9.67703L16.1493 10.1149L15.9189 9.40641L16.5217 8.96836H15.7768L15.5464 8.25977Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.8073 6.52148L13.577 7.23008H12.832L13.4347 7.66813L13.2045 8.37664L13.8073 7.93875L14.41 8.37664L14.1798 7.66813L14.7824 7.23008H14.0375L13.8073 6.52148Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.3048 5.65137L11.0745 6.35996H10.3296L10.9322 6.79793L10.702 7.50645L11.3048 7.06855L11.9076 7.50645L11.6773 6.79793L12.28 6.35996H11.5351L11.3048 5.65137Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110689">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AbkhaziaSvg;
